import ContactForm from '../ContactForm';

export default function ContactMeForm({mt, addonStyle}) {
	return (
		<ContactForm
			mt={mt}
			texts={['I can help you design the best workouts.']}
			title='Contact me'
			to='brugmethod@gmail.com' /* brugmethod@gmail.com */
			sucessMessage='You have successfully sent me an email'
			addonStyle={addonStyle}
		/>
	);
}
